"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = constants;

function constants(x) {
  return function () {
    return x;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-scale/src/constant.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-scale/src/constant.js
// module chunks = 1